import { render, staticRenderFns } from "./ab-cust-dialog.vue?vue&type=template&id=1e83d989&"
import script from "./ab-cust-dialog.vue?vue&type=script&lang=js&"
export * from "./ab-cust-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports